import { Link } from 'react-router-dom';
import { instalacion } from '@tanteo/compartido/instalacion';
import { Lista, PaginaLegal, Pendiente, Seccion } from './PaginaLegal';

/** Borrador público de los Términos de Servicio de la plataforma. */
export function TerminosServicio() {
  const marca = instalacion.nombre;
  return (
    <PaginaLegal titulo="Términos de Servicio">
      <Seccion titulo="1. Aceptación">
        <p>
          1.1. Crear una cuenta o usar {marca} implica aceptar estos Términos y la{' '}
          <Link to="/legal/politica-datos" className="text-info underline">Política de Tratamiento de Datos Personales</Link>.
          La aceptación se da por medios electrónicos y queda registrada con su fecha, hora y versión (Ley 527 de 1999).
        </p>
        <p>1.2. El Negocio se registra a nombre de una persona natural, que debe ser mayor de edad y tener capacidad para contratar.</p>
      </Seccion>

      <Seccion titulo="2. Definiciones">
        <Lista>
          <li><strong>Plataforma:</strong> el servicio {marca}, que funciona en el navegador y puede instalarse como aplicación.</li>
          <li><strong>Negocio:</strong> el establecimiento registrado por su Propietario, que contrata el servicio.</li>
          <li><strong>Propietario:</strong> quien crea el Negocio y lo administra.</li>
          <li><strong>Miembro:</strong> persona que el Propietario invita con un rol: propietario, cajero o contador.</li>
          <li><strong>Tercero:</strong> cliente o proveedor que el Negocio registra.</li>
          <li><strong>Comprobante de venta:</strong> documento interno que la Plataforma genera por cada venta.</li>
          <li>
            {/* eslint-disable-next-line no-restricted-syntax -- el umbral que obliga a facturar, que el producto vigila */}
            <strong>Semáforo:</strong> indicador informativo de los umbrales que pueden obligar al Negocio a facturar electrónicamente.
          </li>
        </Lista>
      </Seccion>

      <Seccion titulo="3. Objeto y descripción del servicio">
        <p>3.1. {marca} es un servicio de software para registrar la operación diaria de un micronegocio. Incluye:</p>
        <Lista>
          <li>venta en mostrador con lector de códigos de barras y comprobantes de venta internos;</li>
          <li>anulación de comprobantes con motivo, sin borrarlos;</li>
          <li>cuadre de caja por día y por cuenta;</li>
          <li>catálogo de productos y carta de códigos;</li>
          {/* eslint-disable-next-line no-restricted-syntax -- facturas recibidas de proveedores */}
          <li>registro de gastos, incluida la lectura del código QR de facturas electrónicas recibidas;</li>
          <li>recetas e inventario de insumos;</li>
          <li>reportes y archivos de exportación;</li>
          <li>invitación de Miembros por rol;</li>
          <li>formulario público para que los clientes del Negocio se registren;</li>
          <li>resúmenes y consultas por Telegram;</li>
          <li>el Semáforo.</li>
        </Lista>
        <p>3.2. Ante cortes de internet, la Plataforma guarda las ventas en el dispositivo y las envía al recuperar la conexión.</p>
        <p>3.3. <strong>El servicio no incluye:</strong></p>
        <Lista>
          {/* eslint-disable-next-line no-restricted-syntax -- aclaración legal que niega la facturación electrónica */}
          <li>facturación electrónica ni documento equivalente;</li>
          <li>contabilidad;</li>
          <li>asesoría tributaria, contable o legal;</li>
          {/* eslint-disable-next-line no-restricted-syntax -- facturas recibidas de proveedores */}
          <li>custodia de los soportes de gastos: la Plataforma lee el código QR de la factura y no guarda el archivo;</li>
          <li>la garantía de que el Negocio cumpla sus obligaciones tributarias.</li>
        </Lista>
      </Seccion>

      <Seccion titulo="4. Naturaleza del comprobante de venta">
        <p>
          4.1. El comprobante de venta es un registro interno.{' '}
          {/* eslint-disable-next-line no-restricted-syntax -- aclaración legal que niega la factura */}
          <strong>No es factura de venta ni documento equivalente.</strong>{' '}
          {/* eslint-disable-next-line no-restricted-syntax -- la leyenda obligatoria del comprobante */}
          <span>Lleva la leyenda «Comprobante interno de venta — no es factura de venta ni documento equivalente».</span>
        </p>
        <p>
          4.2. El consecutivo de cada Negocio lo asigna el servidor. Un comprobante anulado conserva su número, su motivo y su
          fecha, y el número no se reutiliza. Los precios, nombres e impuestos de cada línea quedan fijos al emitirlo.
        </p>
        <p>4.3. Las ventas sin cliente identificado se registran a nombre del consumidor final genérico.</p>
        {/* eslint-disable-next-line no-restricted-syntax -- la obligación de facturar, que decide el Negocio */}
        <p>4.4. Determinar si el Negocio está obligado a facturar es responsabilidad del Negocio y de su asesor. El Semáforo compara los ingresos registrados con los umbrales vigentes y avisa; es informativo y no constituye asesoría tributaria.</p>
      </Seccion>

      <Seccion titulo="5. Cuenta y accesos">
        <p>5.1. El Propietario suministra información veraz y actualizada. Se entra con un código de un solo uso enviado al correo registrado.</p>
        <p>5.2. El Propietario decide a quién invita, con qué rol, y responde por el uso que hagan los Miembros. Puede ver y desconectar las sesiones abiertas de su Negocio.</p>
        <p>5.3. Cada persona es responsable de la confidencialidad de su acceso y del uso que se haga desde su cuenta.</p>
        <p>5.4. Vincular un chat de Telegram es opcional. Se hace con un código de un solo uso que genera el Propietario, y el uso de Telegram se rige además por las condiciones de ese servicio.</p>
      </Seccion>

      <Seccion titulo="6. Precio">
        <p>6.1. <Pendiente>[TBD: el servicio se presta sin costo durante la fase actual / planes y precios.]</Pendiente></p>
        <p>
          6.2. Si se establecen planes de pago, se informarán el precio total con impuestos y sus condiciones con al menos{' '}
          <Pendiente>[TBD: 15]</Pendiente> días de antelación. Requerirán aceptación expresa; sin ella, el Propietario puede
          terminar el servicio sin penalidad.
        </p>
      </Seccion>

      <Seccion titulo="7. Obligaciones del Negocio">
        <p>El Negocio se obliga a:</p>
        <p>7.1. Usar la Plataforma solo para fines lícitos. El contenido que registra es de su exclusiva responsabilidad.</p>
        <p>7.2. Actuar como Responsable del tratamiento de los datos de sus Terceros y de su equipo:</p>
        <Lista>
          <li>contar con su propia política de tratamiento cuando la ley lo exija;</li>
          <li>obtener las autorizaciones necesarias, sin casillas premarcadas, y la del representante legal cuando se trate de menores de edad;</li>
          <li>atender las solicitudes de habeas data;</li>
          <li>usar la acción de supresión cuando proceda.</li>
        </Lista>
        {/* eslint-disable-next-line no-restricted-syntax -- prohibición legal de presentar el comprobante como factura */}
        <p>7.3. No presentar el comprobante de venta como factura ni usarlo para fines que exijan una factura.</p>
        <p>7.4. Cumplir sus obligaciones tributarias y conservar los soportes de sus compras y gastos.</p>
        <p>7.5. Registrar datos correctos de sus Terceros.</p>
        <p>7.6. No revender, sublicenciar ni hacer ingeniería inversa de la Plataforma, ni intentar acceder a datos de otros Negocios.</p>
      </Seccion>

      <Seccion titulo={`8. Obligaciones de ${marca}`}>
        <p>{marca} se obliga a:</p>
        <p>8.1. Prestar el servicio con diligencia, conforme a estos Términos.</p>
        <p>8.2. Mantener las medidas de seguridad descritas en la Política de Tratamiento de Datos Personales:</p>
        <Lista>
          <li>aislamiento entre negocios;</li>
          <li>acceso por código de un solo uso;</li>
          <li>copias de respaldo diarias cifradas;</li>
          <li>registro de auditoría.</li>
        </Lista>
        <p>8.3. Notificar al Negocio los incidentes de seguridad que afecten sus datos.</p>
        <p>8.4. Permitir que el Negocio exporte sus datos en archivos CSV.</p>
        <p>
          8.5. Procurar la disponibilidad continua del servicio, sin garantizarla.{' '}
          <Pendiente>[TBD: objetivo de disponibilidad y ventanas de mantenimiento.]</Pendiente>
        </p>
        <p>8.6. Atender el soporte por <Pendiente>[TBD: canal y horario]</Pendiente>.</p>
      </Seccion>

      <Seccion titulo="9. Tratamiento de datos por cuenta del Negocio (contrato Responsable–Encargado)">
        <p>Esta cláusula es el contrato de transmisión del artículo 2.2.2.25.5.2 del Decreto 1074 de 2015.</p>
        <p>
          9.1. <strong>Alcance.</strong> {marca} trata los datos de los Terceros y del equipo del Negocio únicamente para
          prestar el servicio descrito en la cláusula 3, siguiendo las instrucciones que el Negocio da al usar la
          Plataforma. Eso incluye registrar, consultar, asociar compras, imprimir comprobantes, exportar, respaldar y
          suprimir.
        </p>
        <p>
          9.2. <strong>Límites.</strong> {marca} no usa esos datos para fines propios ni para publicidad. No los cede a
          terceros, salvo a los subencargados de infraestructura listados en la Política. El personal de la Plataforma no
          accede a montos, a datos de Terceros ni al detalle de las ventas de un Negocio, y sus consultas quedan registradas.
        </p>
        <p>9.3. <strong>Obligaciones de {marca} como Encargado</strong> (Ley 1581 de 2012, art. 18):</p>
        <Lista>
          <li>tratar los datos conforme a los principios de la ley;</li>
          <li>guardar confidencialidad;</li>
          <li>mantener las medidas de seguridad;</li>
          <li>actualizar, rectificar o suprimir lo que el Negocio indique dentro de los 5 días hábiles siguientes;</li>
          <li>dar traslado al Negocio, dentro de 2 días hábiles, de las solicitudes de habeas data que reciba;</li>
          <li>informar los incidentes de seguridad;</li>
          <li>permitir al Negocio verificar el cumplimiento;</li>
          <li>informar con <Pendiente>[TBD: días]</Pendiente> de antelación los cambios de subencargados.</li>
        </Lista>
        <p>9.4. <strong>Obligaciones del Negocio como Responsable</strong> (art. 17):</p>
        <Lista>
          <li>contar con la base legal y las autorizaciones;</li>
          <li>definir finalidades lícitas;</li>
          <li>suministrar solo datos cuyo tratamiento esté autorizado;</li>
          <li>responder ante los titulares y la Superintendencia de Industria y Comercio.</li>
        </Lista>
        <p>
          9.5. <strong>Transmisión internacional.</strong> La transmisión a los subencargados ubicados fuera de Colombia se
          ampara en este contrato y en los acuerdos con cada proveedor, y no requiere autorización adicional del titular.
        </p>
        <p>
          9.6. <strong>Al terminar.</strong> {marca} pone los datos a disposición del Negocio para su exportación durante{' '}
          <Pendiente>[TBD: días]</Pendiente> y luego los suprime, salvo deber legal de conservación. Las copias de respaldo se
          eliminan al cumplir su plazo de 90 días.
        </p>
      </Seccion>

      <Seccion titulo="10. Servicios de terceros y límites del servicio">
        <p>
          10.1. El servicio depende de proveedores de base de datos, alojamiento, mensajería y correo, y de Telegram cuando el
          Propietario lo vincula. {marca} no responde por fallas de esos terceros, sin perjuicio de mitigar su impacto.
        </p>
        <p>10.2. El funcionamiento en el local depende de los equipos, la conexión, el lector y la impresora del Negocio.</p>
        <p>10.3. Las ventas guardadas en el dispositivo durante un corte solo quedan en la Plataforma cuando ese dispositivo vuelve a conectarse.</p>
      </Seccion>

      <Seccion titulo="11. Propiedad intelectual">
        <p>
          11.1. La Plataforma, su código, marca, diseño y documentación son de <Pendiente>[TBD: titular]</Pendiente>. El
          Negocio recibe una licencia de uso no exclusiva, intransferible y revocable, limitada a la vigencia de estos
          Términos.
        </p>
        <p>11.2. Los datos que el Negocio registra son y permanecen del Negocio, o de sus titulares según corresponda. {marca} no adquiere derechos sobre ellos.</p>
      </Seccion>

      <Seccion titulo="12. Limitación de responsabilidad">
        <p>
          12.1. {marca} responde por los perjuicios directos causados por dolo o culpa grave. En los demás casos, su
          responsabilidad total se limita a{' '}
          <Pendiente>[TBD: el valor pagado en los 12 meses anteriores / monto fijo si el servicio es gratuito]</Pendiente>.
        </p>
        <p>12.2. {marca} no responde por:</p>
        <Lista>
          <li>las decisiones tributarias o contables del Negocio;</li>
          <li>el contenido y la veracidad de lo que el Negocio registra;</li>
          <li>las decisiones de tratamiento que el Negocio adopta como Responsable;</li>
          <li>el uso de la cuenta por Miembros autorizados;</li>
          <li>los perjuicios indirectos o el lucro cesante.</li>
        </Lista>
        <p>12.3. Nada en estos Términos limita la responsabilidad que la ley no permite limitar, ni los derechos irrenunciables que correspondan al Negocio (Ley 1480 de 2011).</p>
      </Seccion>

      <Seccion titulo="13. Suspensión y terminación">
        <p>13.1. El Propietario puede terminar el servicio en cualquier momento solicitándolo por <Pendiente>[TBD: canal]</Pendiente>.</p>
        <p>
          13.2. {marca} puede suspender o terminar el servicio por incumplimiento grave, uso ilícito o riesgo para la
          Plataforma o para otros Negocios, con notificación al Propietario. Mientras dure la suspensión el Negocio no puede
          registrar operaciones. <Pendiente>[TBD: si conserva la consulta y la exportación.]</Pendiente>
        </p>
        <p>13.3. Al terminar:</p>
        <Lista>
          <li>se revocan los accesos;</li>
          <li>se aplica la cláusula 9.6;</li>
          <li>se suprimen los datos de la cuenta según la Política de Tratamiento de Datos Personales.</li>
        </Lista>
        <p>13.4. Sobreviven a la terminación las cláusulas 4, 9, 11, 12 y 15.</p>
      </Seccion>

      <Seccion titulo="14. Modificaciones">
        <p>
          {marca} puede modificar estos Términos. Los cambios sustanciales se notifican al correo del Propietario con al menos{' '}
          <Pendiente>[TBD: 15]</Pendiente> días de antelación. Si el Propietario no los acepta, puede terminar el servicio sin
          penalidad antes de que entren en vigor.
        </p>
      </Seccion>

      <Seccion titulo="15. Ley aplicable y controversias">
        <p>15.1. Estos Términos se rigen por las leyes de la República de Colombia.</p>
        <p>
          15.2. Las partes procurarán un arreglo directo durante <Pendiente>[TBD: 30]</Pendiente> días. Agotado ese plazo, las
          controversias se someten a la jurisdicción ordinaria de <Pendiente>[TBD: ciudad]</Pendiente>, sin perjuicio de las
          competencias de la Superintendencia de Industria y Comercio.
        </p>
        <p>
          15.3. Las notificaciones se envían al correo registrado del Propietario y a{' '}
          <Pendiente>[TBD: correo de contacto]</Pendiente> para {marca}, y tienen plena validez (Ley 527 de 1999).
        </p>
      </Seccion>

      <Seccion titulo="Datos del prestador">
        <Lista>
          <li>
            <strong>Prestador:</strong> <Pendiente>[TBD: nombre completo o razón social]</Pendiente>,{' '}
            <Pendiente>[TBD: tipo y número de documento o NIT]</Pendiente>, titular de la marca «{marca}».
          </li>
          <li><strong>Domicilio:</strong> <Pendiente>[TBD: ciudad]</Pendiente>, Colombia.</li>
          <li><strong>Dirección:</strong> <Pendiente>[TBD: dirección física]</Pendiente>.</li>
          <li>
            <strong>Contacto:</strong> <Pendiente>[TBD: correo de contacto]</Pendiente> · <Pendiente>[TBD: teléfono]</Pendiente>.
          </li>
        </Lista>
      </Seccion>
    </PaginaLegal>
  );
}
